import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPaperclip } = FiIcons;

export default function StickyNote({ note, index }) {
  // Generate a slight random rotation for realism
  const rotation = index % 2 === 0 ? -2 : 3;
  
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: index * 0.1 }}
      whileHover={{ scale: 1.05, rotate: 0, zIndex: 10 }}
      className="relative w-48 h-48 bg-gradient-to-br from-yellow-200 to-yellow-300 p-4 shadow-md rounded-br-2xl flex flex-col transition-all cursor-pointer border border-yellow-400/50"
      style={{ rotate: `${rotation}deg` }}
    >
      {/* Tape/Clip effect */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-12 h-6 bg-white/40 backdrop-blur-sm transform -rotate-2 shadow-sm border border-white/50"></div>
      
      <div className="flex-1 mt-2">
        <p className="font-medium text-slate-800 text-sm leading-relaxed font-sans">
          {note.text}
        </p>
      </div>
      
      <div className="mt-auto flex justify-between items-center text-xs text-yellow-800/70 border-t border-yellow-400/30 pt-2">
        <span className="font-semibold">{note.author}</span>
        {note.type === 'urgent' && (
          <span className="bg-red-500 text-white px-2 py-0.5 rounded-full text-[10px] font-bold">
            URGENT
          </span>
        )}
      </div>
    </motion.div>
  );
}